import ClassManagerFeature from './ClassManagerFeature';

export default ClassManagerFeature;
export { ClassManagerFeature };
